// @core/api/endpoints/team/activate_team_avatar.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ActivateTeamAvatarRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Set active team avatar
 * Sets a previously uploaded avatar as the team's active display image.
 */
export async function ActivateTeamAvatar(
  team_id: string,
  avatar_id: string,
  data: ActivateTeamAvatarRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/avatars/:avatar_id/activate`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':avatar_id', encodeURIComponent(avatar_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
